import Breadcrumbs from "components/Breadcrumbs";
import SEO from "components/SEO";
import ContactComponent from "components/contactUs";
import { pagePadding } from "data/commonClasses";
import { fetchParallel, fetchPost } from "functions";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function Contactus({ data }) {
  const { t } = useTranslation();

  let breadcrumbs = [{ text: t("home"), href: "/" }, { text: t("contactUs") }];
  return (
    <div
      className={twMerge(
        "flex flex-col w-full",
        pagePadding
      )}
    >
      <SEO title={t("contactUs")} description={t("contactusDescription")} />
      <Breadcrumbs items={breadcrumbs} />
      <ContactComponent data={data} />
    </div>
  );
}

export async function getServerSideProps(context) { 
  let { lang } = context.query;
  let data = {};

  let response = await fetchPost({ apiName: "oeaBuilding", reqBody: { lang } });
  data = response?.response;
  
  return { props: { data } };
}
